import {Vue} from 'ui.vue';

import Const from './Const';

import 'bxmaker.authuserphone.core';
import './components/BXmakerAuthuserphoneEdit.js';


export class Edit {
    constructor(rootId, data) {
        this.rootId = rootId;
        this.data = data;
        this.rand = data.rand;
        this.instance = null;

        this.initTemplate()
    }


    initTemplate() {
        const context = this;

        this.instance = Vue.createApp({
            name: 'BXmakerAuthuserphoneEditContainer_' + this.rand,
            key: this.rand,
            data() {
                return {
                    data: context.data,
                    rand: context.data.rand,

                    isAuthorized: context.data.isAuthorized,

                    isEnabledConfirmBySmsCode: context.data.isEnabledConfirmBySmsCode,
                    isEnabledConfirmByUserCall: context.data.isEnabledConfirmByUserCall,
                    isEnabledConfirmByBotCall: context.data.isEnabledConfirmByBotCall,
                    isEnabledConfirmByBotSpeech: context.data.isEnabledConfirmByBotSpeech,
                    isEnabledConfirmBySimPush: context.data.isEnabledConfirmBySimPush,

                    confirmationType: Const.CONFIRM_TYPE_SMS_CODE,
                    isShowConfirm: false, // показывать блок с проверкой

                    phoneMaskParams: context.data.phoneMaskParams,

                    captchaId: false,
                    captchaCode: false,
                    captchaSrc: false,
                    captchaLength: false,
                    captchaLoader: false,

                    phone: '', // введенный телефон
                    formattedPhone: '', // форматированный номер телефона

                    phoneError: '', // ошибка при проверкке номера телефона

                    currentPhone: context.data.currentPhone, //текущий номер телефона, выводится при смене
                    currentFormattedPhone: context.data.currentFormattedPhone, // текущий форматированный номер телефона, выводится при смене

                    message: false, // сообщение
                    error: false, // сообщение об ошибкой

                    expandData: {},

                    // sms
                    smsCodeLength: 4,
                    smsCodeTimeout: 0,
                    smsCode: '',
                    smsCodeError: '',
                    smsCodeStartLoader: false,
                    smsCodeCheckLoader: false,

                    //проверка через звонок от пользователя
                    userCallTo: '',
                    userCallStartLoader: false,
                    userCallCheckLoader: false,
                    userCallTimeout: 0,

                    // звонок от робота
                    botCallCode: '',
                    botCallLength: 4,
                    botCallTimeout: 0,
                    botCallStartLoader: false,
                    botCallCheckLoader: false,


                    // голосовой код
                    botSpeechCode: '',
                    botSpeechLength: 4,
                    botSpeechTimeout: 0,
                    botSpeechStartLoader: false,
                    botSpeechCheckLoader: false,

                    // SIM-push
                    simPush: '',
                    simPushTimeout: 0,
                    simPushDelay: 3,
                    simPushStartLoader: false,
                    simPushCheckLoader: false,

                };
            },
            computed: {
                localize() {
                    return BX.Vue.getFilteredPhrases('BXMAKER_AUTHUSERPHONE_EDIT_');
                },
                const() {
                    return Const;
                },
                baseAjaxData() {
                    return {
                        siteId: this.data.siteId,
                        template: this.data.template,
                        parameters: this.data.parameters,
                        rand: this.data.rand,
                        expandData: {...this.expandData},
                    }
                },
                /**
                 * Вернет массив вараинтов подтверждения номера телефона
                 * в нужном нам порядке
                 * @returns {string[]}
                 */
                confirmationList() {
                    let list = this.data.confirmQueue;

                    if (!this.isEnabledConfirmBySmsCode) {
                        list = list.filter(row => row !== this.const.CONFIRM_TYPE_SMS_CODE);
                    }
                    if (!this.isEnabledConfirmByUserCall) {
                        list = list.filter(row => row !== this.const.CONFIRM_TYPE_USER_CALL);
                    }
                    if (!this.isEnabledConfirmByBotCall) {
                        list = list.filter(row => row !== this.const.CONFIRM_TYPE_BOT_CALL);
                    }
                    if (!this.isEnabledConfirmByBotSpeech) {
                        list = list.filter(row => row !== this.const.CONFIRM_TYPE_BOT_SPEECH);
                    }
                    if (!this.isEnabledConfirmBySimPush) {
                        list = list.filter(row => row !== this.const.CONFIRM_TYPE_SIM_PUSH);
                    }

                    if (list.length <= 0) {
                        list.push(this.const.CONFIRM_TYPE_SMS_CODE);
                    }
                    return list;
                },

                startLoader() {
                    return this.smsCodeStartLoader || this.userCallStartLoader || this.botCallStartLoader || this.botSpeechStartLoader || this.simPushStartLoader;
                },

                checkLoader() {
                    return this.smsCodeCheckLoader || this.userCallCheckLoader || this.botCallCheckLoader || this.botSpeechCheckLoader || this.simPushCheckLoader;
                },

                isNeedShowConfirmSmsCode() {
                    return this.isAuthorized
                        && this.isShowConfirm
                        && this.confirmationType === this.const.CONFIRM_TYPE_SMS_CODE;
                },
                isNeedShowConfirmUserCall() {
                    return this.isAuthorized
                        && this.isShowConfirm
                        && this.confirmationType === this.const.CONFIRM_TYPE_USER_CALL;
                },
                isNeedShowConfirmBotCall() {
                    return this.isAuthorized
                        && this.isShowConfirm
                        && this.confirmationType === this.const.CONFIRM_TYPE_BOT_CALL;
                },
                isNeedShowConfirmBotSpeech() {
                    return this.isAuthorized
                        && this.isShowConfirm
                        && this.confirmationType === this.const.CONFIRM_TYPE_BOT_SPEECH;
                },
                isNeedShowConfirmSimPush() {
                    return this.isAuthorized
                        && this.isShowConfirm
                        && this.confirmationType === this.const.CONFIRM_TYPE_SIM_PUSH;
                },
                isNeedShowChangeConfirm() {
                    return this.isAuthorized
                        && this.isShowConfirm
                        && this.confirmationList.length > 1;
                },
                isFullCaptcha() {
                    if (!this.captchaId) {
                        return true;
                    }

                    if (this.captchaLength === this.captchaCode.toString().length) {
                        return true;
                    }

                    return false;
                },
                isEnabledPhoneMaskTypeBitrix(){
                    return this.phoneMaskParams && this.phoneMaskParams.type && this.phoneMaskParams.type === 'bitrix';
                },
            },
            watch:{
                confirmationType(val, oldVal){
                    BX.Vue.event.$emit('BXmakerAuthuserphoneEditChangeConfirmationType', {
                        value: val,
                        oldValue: oldVal,
                        rand: this.rand,
                    });
                },
                isShowConfirm(val, oldVal){
                    BX.Vue.event.$emit('BXmakerAuthuserphoneEditChangeShowConfirm', {
                        value: val,
                        oldValue: oldVal,
                        rand: this.rand,
                    });
                }
            },
            created() {
                if (this.confirmationList.length > 0 && this.confirmationList[0] !== this.confirmationType) {
                    this.setConfirmType(this.confirmationList[0]);
                }
            },
            methods: {
                resetExpandData() {
                    this.expandData = {};
                },
                setExpandData(name, value) {
                    this.expandData[name] = value;
                },
                // при клике на кнпоку  другйо вариант подтверждения
                changeConfirmType() {
                    let list = this.confirmationList;
                    let current = this.confirmationType;
                    if (list.length > 1) {
                        let newconfirmationType = list[0];
                        let index = list.indexOf(current);
                        if (index > -1 && !!list[index + 1]) {
                            newconfirmationType = list[index + 1];
                        }
                        if (newconfirmationType !== current) {
                            this.setConfirmType(newconfirmationType);
                            this.startConfirm();
                        }
                    }
                },

                // установка текущего варианта подтверждения
                setConfirmType(type) {
                    let list = this.confirmationList;
                    if (~list.indexOf(type)) {
                        this.resetMessage();
                        this.confirmationType = type;
                    }
                },

                //Показать блок подтверждения
                showConfirm() {
                    this.isShowConfirm = true;
                },
                // скрыть блок подтверждения
                hideConfirm() {
                    this.isShowConfirm = false;
                },

                // сброс мообщений об ошибках или успехах
                resetMessage() {
                    this.phoneError = false;
                    this.message = false;
                    this.error = false;
                },


                //запись сообщения
                setMessage(msg) {
                    this.message = msg;
                    this.error = false;
                },

                //запись ошибки
                setError(msg) {
                    this.message = msg;
                    this.error = true;
                },


                // разбор ошибок
                parseError(error) {

                    if (error.more && error.more.formattedPhone) {
                        this.setFormattedPhone(error.more.formattedPhone);
                    }


                    switch (error.code) {
                        // case 'ERROR_INVALID_SESSID': {
                        //     if(error.more.sessid)
                        //     {
                        //         BX.message({'bitrix_sessid' : error.more.sessid});
                        //     }
                        //     break;
                        // }
                        case 'ERROR_INVALID_PHONE': {
                            this.resetCaptcha();
                            this.hideConfirm();
                            this.setPhoneError(error.msg);
                            break;
                        }
                        case 'ERROR_NEED_WAIT_TIMEOUT': {
                            this.resetCaptcha();
                            this.showConfirm();


                            if (this.confirmationType === this.const.CONFIRM_TYPE_SMS_CODE) {
                                this.setSmsCodeTimeout(error.more.timeout);
                                this.setSmsCodeLength(error.more.length);

                            } else if (this.confirmationType === this.const.CONFIRM_TYPE_USER_CALL) {
                                this.setUserCallTimeout(error.more.timeout);
                                if (error.more.callTo) {
                                    this.setUserCallTo(error.more.callTo);
                                }
                            } else if (this.confirmationType === this.const.CONFIRM_TYPE_BOT_CALL) {
                                this.setBotCallTimeout(error.more.timeout);
                                this.setBotCallLength(error.more.length);
                            } else if (this.confirmationType === this.const.CONFIRM_TYPE_BOT_SPEECH) {
                                this.setBotSpeechTimeout(error.more.timeout);
                                this.setBotSpeechLength(error.more.length);
                            } else if (this.confirmationType === this.const.CONFIRM_TYPE_SIM_PUSH) {
                                this.setSimPushTimeout(error.more.timeout);
                                this.setSimPush(1);
                            }
                            break;
                        }
                        case 'ERROR_NEED_CAPTCHA': {
                            this.setCaptchaCode('');
                            this.setCaptchaId(error.more.captchaId)
                            this.setCaptchaSrc(error.more.captchaSrc)
                            this.setCaptchaLength(error.more.captchaLength)

                            break;
                        }
                        case 'ERROR_INVALID_SMS_CODE': {
                            this.setSmsCode('');
                            this.setSmsCodeError(error.msg);
                            break;
                        }
                        case 'SERVICE_ERROR_UNKNOWN':
                        case 'SERVICE_ERROR_RESPONSE': {
                            this.resetCaptcha();
                            this.showConfirm();
                            this.setError(error.msg);
                            break;
                        }
                        default: {
                            this.setError(error.msg);
                            break;
                        }
                    }
                },


                setPhone(value) {
                    this.phone = value;
                },
                setPhoneError(value) {
                    this.phoneError = value;
                },
                setFormattedPhone(value) {
                    this.formattedPhone = value;
                },

                setCurrentPhone(value) {
                    this.currentPhone = value;
                },

                setCurrentFormattedPhone(value) {
                    this.currentFormattedPhone = value;
                },

                setIsAuthorized(value) {
                    this.isAuthorized = !!value;
                },

                // sms -------------------------
                setSmsCodeLength(value) {
                    this.smsCodeLength = value;
                },
                setSmsCodeTimeout(value) {
                    this.smsCodeTimeout = value;
                },
                setSmsCode(value) {
                    this.smsCode = value;
                },
                setSmsCodeError(value) {
                    this.smsCodeError = value;
                },
                setSmsCodeStartLoader(value) {
                    this.smsCodeStartLoader = value;
                },
                setSmsCodeCheckLoader(value) {
                    this.smsCodeCheckLoader = value;
                },


                //проверка через звонок от пользователя
                setUserCallTo(value) {
                    this.userCallTo = value;
                },
                setUserCallStartLoader(value) {
                    this.userCallStartLoader = value;
                },
                setUserCallCheckLoader(value) {
                    this.userCallCheckLoader = value;
                },
                setUserCallTimeout(value) {
                    this.userCallTimeout = value;
                },

                // звонок от робота
                setBotCallCode(value) {
                    this.botCallCode = value;
                },
                setBotCallLength(value) {
                    this.botCallLength = value;
                },
                setBotCallTimeout(value) {
                    this.botCallTimeout = value;
                },
                setBotCallStartLoader(value) {
                    this.botCallStartLoader = value;
                },
                setBotCallCheckLoader(value) {
                    this.botCallCheckLoader = value;
                },

                // голосовой код
                setBotSpeechCode(value) {
                    this.botSpeechCode = value;
                },
                setBotSpeechLength(value) {
                    this.botSpeechLength = value;
                },
                setBotSpeechTimeout(value) {
                    this.botSpeechTimeout = value;
                },
                setBotSpeechStartLoader(value) {
                    this.botSpeechStartLoader = value;
                },
                setBotSpeechCheckLoader(value) {
                    this.botSpeechCheckLoader = value;
                },

                // SIM-push
                setSimPush(value) {
                    this.simPush = value;
                },
                setSimPushTimeout(value) {
                    this.simPushTimeout = value;
                },
                setSimPushDelay(value) {
                    this.simPushDelay = value;
                },
                setSimPushStartLoader(value) {
                    this.simPushStartLoader = value;
                },
                setSimPushCheckLoader(value) {
                    this.simPushCheckLoader = value;
                },


                /**
                 * Запрос новой капчи
                 */
                refreshCaptcha() {
                    this.resetMessage();

                    this.captchaLoader = true;

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'refreshCaptcha',
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {

                            BX.Vue.event.$emit('BXmakerAuthuserphoneEditAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            if (r.response) {

                                this.captchaId = r.response.captchaId;
                                this.captchaSrc = r.response.captchaSrc;
                                this.captchaCode = '';
                                this.captchaLength = r.response.captchaLength;

                            } else {
                                this.parseError(r.error);
                            }

                            this.captchaLoader = false;
                        },
                        onfailure: (e) => {
                            this.captchaLoader = false;
                        }
                    });

                },

                /**
                 * СБрос состояния капчи
                 */
                resetCaptcha() {
                    this.captchaCode = false;
                    this.captchaId = false;
                    this.captchaSrc = false;
                    this.captchaLength = false;
                },

                /**
                 * СБрос состояния капчи
                 */
                hideCaptcha() {
                    this.captchaSrc = false;
                },

                //установка  кода с картиник
                setCaptchaCode(value) {
                    this.captchaCode = value;
                },
                setCaptchaId(value) {
                    this.captchaId = value;
                },
                setCaptchaSrc(value) {
                    this.captchaSrc = value;
                },
                setCaptchaLength(value) {
                    this.captchaLength = +value;
                },

                //Запуск начала проверки
                startConfirm() {

                    switch (this.confirmationType) {
                        case this.const.CONFIRM_TYPE_SMS_CODE: {
                            this.startConfirmSmsCode();
                            break;
                        }
                        case this.const.CONFIRM_TYPE_USER_CALL: {
                            this.startConfirmUserCall();
                            break;
                        }
                        case this.const.CONFIRM_TYPE_BOT_CALL: {
                            this.startConfirmBotCall();
                            break;
                        }
                        case this.const.CONFIRM_TYPE_BOT_SPEECH: {
                            this.startConfirmBotSpeech();
                            break;
                        }
                        case this.const.CONFIRM_TYPE_SIM_PUSH: {
                            this.startConfirmSimPush();
                            break;
                        }
                    }
                },

                /**
                 * Начало проверки через код в смс
                 */
                startConfirmSmsCode() {
                    if (this.smsCodeStartLoader) {
                        return false;
                    }

                    this.resetMessage();
                    // this.hideCaptcha();

                    this.setSmsCodeStartLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'startConfirm',
                        type: this.const.CONFIRM_TYPE_SMS_CODE,
                        captchaId: this.captchaId,
                        captchaCode: this.captchaCode,
                        phone: this.phone,
                    });


                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {

                            BX.Vue.event.$emit('BXmakerAuthuserphoneEditAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {
                                this.setFormattedPhone(r.response.formattedPhone);
                                this.setSmsCodeLength(r.response.length);
                                this.setSmsCodeTimeout(r.response.timeout);

                                this.resetCaptcha();
                                this.showConfirm();

                            } else {
                                this.parseError(r.error);

                            }

                            this.setSmsCodeStartLoader(false);
                        },
                        onfailure: (e) => {
                            this.setSmsCodeStartLoader(false);
                        }
                    });
                },

                /**
                 * Проверка код из смс
                 */
                checkConfirmSmsCode() {
                    if (this.smsCodeCheckLoader) {
                        return false;
                    }

                    this.resetMessage();
                    // this.hideCaptcha()

                    this.setSmsCodeCheckLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'checkConfirm',
                        type: this.const.CONFIRM_TYPE_SMS_CODE,
                        captchaId: this.captchaId,
                        captchaCode: this.captchaCode,
                        phone: this.phone,
                        code: this.smsCode,
                    });


                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEditAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                BX.Vue.event.$emit('BXmakerAuthuserphoneEditConfirmIsChecked', {
                                    request: requestData,
                                    result: r,
                                });

                                this.hideConfirm();
                                this.setPhone('');
                                this.setFormattedPhone('');
                                this.setMessage(r.response.msg);
                                this.setCurrentPhone(r.response.currentPhone);
                                this.setCurrentFormattedPhone(r.response.currentFormattedPhone);


                            } else {
                                this.parseError(r.error);
                            }

                            this.setSmsCodeCheckLoader(false);
                        },
                        onfailure: (e) => {
                            this.setSmsCodeCheckLoader(false);
                        }
                    });
                },

                /**
                 * Начало проверки через звонок от пользователя
                 */
                startConfirmUserCall() {
                    if (this.userCallStartLoader) {
                        return false;
                    }
                    this.resetMessage();
                    // this.hideCaptcha()

                    this.setUserCallStartLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'startConfirm',
                        type: this.const.CONFIRM_TYPE_USER_CALL,
                        captchaId: this.captchaId,
                        captchaCode: this.captchaCode,
                        phone: this.phone,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {

                            BX.Vue.event.$emit('BXmakerAuthuserphoneEditAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setFormattedPhone(r.response.formattedPhone);

                                this.setUserCallTo(r.response.callTo);
                                this.setUserCallTimeout(r.response.timeout);

                                this.resetCaptcha()

                                this.showConfirm();

                            } else {
                                this.parseError(r.error);
                            }

                            this.setUserCallStartLoader(false);
                        },
                        onfailure: (e) => {
                            this.setUserCallStartLoader(false);
                        }
                    });
                },

                /**
                 * Проверка звонка от пользователя
                 */
                checkConfirmUserCall() {
                    if (this.userCallCheckLoader) {
                        return false;
                    }
                    this.resetMessage();
                    // this.hideCaptcha()

                    this.setUserCallCheckLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'checkConfirm',
                        type: this.const.CONFIRM_TYPE_USER_CALL,
                        captchaId: this.captchaId,
                        captchaCode: this.captchaCode,
                        phone: this.phone,
                        code: this.userCallTo,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEditAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                BX.Vue.event.$emit('BXmakerAuthuserphoneEditConfirmIsChecked', {
                                    request: requestData,
                                    result: r,
                                });


                                this.hideConfirm();
                                this.setPhone('');
                                this.setFormattedPhone('');
                                this.setMessage(r.response.msg);
                                this.setCurrentPhone(r.response.currentPhone);
                                this.setCurrentFormattedPhone(r.response.currentFormattedPhone);

                            } else {
                                this.parseError(r.error);
                            }

                            this.setUserCallCheckLoader(false);
                        },
                        onfailure: (e) => {
                            this.setUserCallCheckLoader(false);
                        }
                    });
                },

                /**
                 * Начало подтверждения через звонок от бота
                 */
                startConfirmBotCall() {
                    if (this.botCallStartLoader) {
                        return false;
                    }
                    this.resetMessage();
                    // this.hideCaptcha();

                    this.setBotCallStartLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'startConfirm',
                        type: this.const.CONFIRM_TYPE_BOT_CALL,
                        phone: this.phone,
                        captchaId: this.captchaId,
                        captchaCode: this.captchaCode,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEditAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setFormattedPhone(r.response.formattedPhone);
                                this.setBotCallLength(r.response.length);
                                this.setBotCallTimeout(r.response.timeout);

                                this.resetCaptcha()

                                this.showConfirm();

                            } else {
                                this.parseError(r.error);
                            }

                            this.setBotCallStartLoader(false);
                        },
                        onfailure: (e) => {
                            this.setBotCallStartLoader(false);
                        }
                    });
                },

                /**
                 * Проверка звонка от робота
                 */
                checkConfirmBotCall() {
                    if (this.botCallCheckLoader) {
                        return false;
                    }
                    this.resetMessage();
                    // this.hideCaptcha()

                    this.setBotCallCheckLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'checkConfirm',
                        type: this.const.CONFIRM_TYPE_BOT_CALL,
                        phone: this.phone,
                        code: this.botCallCode,
                        captchaId: this.captchaId,
                        captchaCode: this.captchaCode,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEditAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                BX.Vue.event.$emit('BXmakerAuthuserphoneEditConfirmIsChecked', {
                                    request: requestData,
                                    result: r,
                                });

                                this.hideConfirm();
                                this.setPhone('');
                                this.setFormattedPhone('');
                                this.setMessage(r.response.msg);
                                this.setCurrentPhone(r.response.currentPhone);
                                this.setCurrentFormattedPhone(r.response.currentFormattedPhone);

                            } else {
                                this.parseError(r.error);
                            }

                            this.setBotCallCheckLoader(false);
                        },
                        onfailure: (e) => {
                            this.setBotCallCheckLoader(false);
                        }
                    });
                },

                /**
                 * Начало подтверждения через голосовой код
                 */
                startConfirmBotSpeech() {
                    if (this.botSpeechStartLoader) {
                        return false;
                    }
                    this.resetMessage();
                    // this.hideCaptcha();

                    this.setBotSpeechStartLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'startConfirm',
                        type: this.const.CONFIRM_TYPE_BOT_SPEECH,
                        phone: this.phone,
                        captchaId: this.captchaId,
                        captchaCode: this.captchaCode,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEditAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setFormattedPhone(r.response.formattedPhone);
                                this.setBotSpeechLength(r.response.length);
                                this.setBotSpeechTimeout(r.response.timeout);

                                this.resetCaptcha()

                                this.showConfirm();

                            } else {
                                this.parseError(r.error);
                            }

                            this.setBotSpeechStartLoader(false);
                        },
                        onfailure: (e) => {
                            this.setBotSpeechStartLoader(false);
                        }
                    });
                },

                /**
                 * Проверка голосового кода
                 */
                checkConfirmBotSpeech() {
                    if (this.botSpeechCheckLoader) {
                        return false;
                    }
                    this.resetMessage();
                    // this.hideCaptcha()

                    this.setBotSpeechCheckLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'checkConfirm',
                        type: this.const.CONFIRM_TYPE_BOT_SPEECH,
                        phone: this.phone,
                        code: this.botSpeechCode,
                        captchaId: this.captchaId,
                        captchaCode: this.captchaCode,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEditAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                BX.Vue.event.$emit('BXmakerAuthuserphoneEditConfirmIsChecked', {
                                    request: requestData,
                                    result: r,
                                });

                                this.hideConfirm();
                                this.setPhone('');
                                this.setFormattedPhone('');
                                this.setMessage(r.response.msg);
                                this.setCurrentPhone(r.response.currentPhone);
                                this.setCurrentFormattedPhone(r.response.currentFormattedPhone);

                            } else {
                                this.parseError(r.error);
                            }

                            this.setBotSpeechCheckLoader(false);
                        },
                        onfailure: (e) => {
                            this.setBotSpeechCheckLoader(false);
                        }
                    });
                },


                /**
                 * Начало подтверждения через SIM-push
                 */
                startConfirmSimPush() {
                    if (this.simPushStartLoader) {
                        return false;
                    }
                    this.resetMessage();
                    // this.hideCaptcha();

                    this.setSimPushStartLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'startConfirm',
                        type: this.const.CONFIRM_TYPE_SIM_PUSH,
                        phone: this.phone,
                        captchaId: this.captchaId,
                        captchaCode: this.captchaCode,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEditAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setFormattedPhone(r.response.formattedPhone);
                                this.setSimPushTimeout(r.response.timeout);
                                this.setSimPush(1);

                                if(!!r.response.delay)
                                {
                                    if(this._simPushDelayTimeout)
                                    {
                                        clearTimeout(this._simPushDelayTimeout);
                                    }

                                    this.setSimPushDelay(+r.response.delay);
                                    this._simPushDelayTimeout = setTimeout(() => {
                                        this.setSimPushDelay(0);
                                    }, 1000 * (+r.response.delay));
                                }


                                this.resetCaptcha()

                                this.showConfirm();

                            } else {
                                this.parseError(r.error);
                            }

                            this.setSimPushStartLoader(false);
                        },
                        onfailure: (e) => {
                            this.setSimPushStartLoader(false);
                        }
                    });
                },

                /**
                 * Проверка SIM-push
                 */
                checkConfirmSimPush() {
                    if (this.simPushCheckLoader) {
                        return false;
                    }
                    this.resetMessage();
                    // this.hideCaptcha()

                    this.setSimPushCheckLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'checkConfirm',
                        type: this.const.CONFIRM_TYPE_SIM_PUSH,
                        phone: this.phone,
                        code: this.simPush,
                        captchaId: this.captchaId,
                        captchaCode: this.captchaCode,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEditAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                BX.Vue.event.$emit('BXmakerAuthuserphoneEditConfirmIsChecked', {
                                    request: requestData,
                                    result: r,
                                });

                                this.hideConfirm();
                                this.setPhone('');
                                this.setFormattedPhone('');
                                this.setMessage(r.response.msg);
                                this.setCurrentPhone(r.response.currentPhone);
                                this.setCurrentFormattedPhone(r.response.currentFormattedPhone);

                            } else {
                                this.parseError(r.error);
                            }

                            this.setSimPushCheckLoader(false);
                        },
                        onfailure: (e) => {
                            this.setSimPushCheckLoader(false);
                        }
                    });
                },

            },
            template: `<BXmakerAuthuserphoneEdit :key="data.rand" />`,
        });

        this.instance.mount('#' + this.rootId);

        return new Promise((resolve, reject) => resolve());
    }

}